
const it = {
    product: {

    },
    productModel: {
        list: 'Elenco Modelli Prodotto',
        name: 'Modello',
        code: 'Codice',
        shortDescription: 'Descrizione Breve',
        mutateSubtitle: 'Modifica Modello Prodotto',
        description: 'Descrizione',
        thumbnail: 'Miniatura',
        image: 'Immagine',
        optionalsSection: 'Opzioni disponibili',
        materialType: {
            label: 'Tipo di Materiale',
            ALL: 'Tutti',
            PVC: 'PVC',
            WOOD: 'Legno',
            ALUMINIUM: 'Alluminio',
            NONE: 'Non definito'
        },
        tabName: {
            PVC: 'Modelli in PVC',
            WOOD: 'Modelli in Legno',
            ALUMINIUM: 'Modelli in Alluminio',
        },
        selectProductModel: 'Modello',
        connectProductModel: 'Collega Modello Prodotto',
        connectPantone: 'Collega Pantone',
        manage: {
            title: 'Gestione Modello Prodotto',
            subtitle: 'Gestione dei dettagli del modello prodotto',
        },
        axisXMin: 'Larghezza Minima',
        axisXMax: 'Larghezza Massima',
        axisYMin: 'Altezza Minima',
        axisYMax: 'Altezza Massima',
        deltaAxisXMeasureHole: 'Delta Larghezza Misura Foro',
        deltaAxisYMeasureHole: 'Delta Altezza Misura Foro',
        optionals: {
            isQuoteEnabled: 'Abilitato per Preventivo',
            isOrderEnabled: 'Abilitato per Ordine',
            isUsedForPriceCalculation: 'Usa per Calcolo del Prezzo',
            showPriceOnRecap: 'Mostra dettaglio Prezzo al rivenditore',
        }

    },
    productModelOptional: {
        title: 'Gestione Accessori Modello Prodotto',
        subtitleBoth: 'Optional: {colorName} - Pantone: {pantoneName}',
        subtitleOptional: '{optionalType}: {optionalName}',
        subtitleProductModel: 'Modello: {productModelName}',

    },
    productModelMeasureGroup: {
        title: 'Gruppi Misura Modello Prodotto',
        subtitleMeasureGroup: 'Gruppo Misura: {measureGroupName}',
        subtitleProductModel: 'Modello Prodotto: {productModelName}',
        selectMeasureGroup: 'Seleziona Gruppo di Misura',
        connectMeasureGroup: 'Collega Gruppo di Misura',
        subtitleBoth: 'Gruppo di Misura: {measureGroupName} - Modello Prodotto: {productModelName}',
    }
}
export default it